module.exports = __webpack_public_path__ + "img/img-7updao.2f71b4ce.png";